module.exports = __webpack_public_path__ + "img/marketing.bc0a1894.svg";